import styled from 'styled-components';

export const ButtonWrapper = styled.a`
  background: ${props => props.theme.colors[props.background]};
  display: flex;
  align-self: center;
  white-space: nowrap;
  justify-content: center;
  margin: ${props => (props.margin ? props.margin : '30px 0')};
  border-radius: 2px;
  border: 1px solid ${props => (props.borderColor ? props.theme.colors[props.borderColor] : 'none')};
  cursor: pointer;
  text-decoration: none;
  width: ${props => (props.width ? props.width : 'auto')};
`;

export const ButtonLabel = styled.div`
  color: ${props => props.theme.colors[props.color]};
  font-size: ${props => (props.size ? props.size : '13px')};
  padding: 8px;
  font-family: ${props => (props.isTitleNarrowMedium ? `${props.theme.fontSets.narrowMedium}` : `${props.theme.fontSets.narrowRegular}`)};
`;



// WEBPACK FOOTER //
// ./src/components/shared/StandingButton/styles.js